module.exports = __webpack_public_path__ + "static/sydney2018-groove-0ff560d65386d76a234d2d071ea460c7.jpeg";